import { render, staticRenderFns } from "./ColorContentUnitBox.vue?vue&type=template&id=71125842&scoped=true&lang=pug&"
import script from "./ColorContentUnitBox.vue?vue&type=script&lang=ts&"
export * from "./ColorContentUnitBox.vue?vue&type=script&lang=ts&"
import style0 from "./ColorContentUnitBox.vue?vue&type=style&index=0&id=71125842&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71125842",
  null
  
)

export default component.exports